import { render, staticRenderFns } from "./customerPriceList.vue?vue&type=template&id=16ebbc3c&"
import script from "./customerPriceList.vue?vue&type=script&lang=js&"
export * from "./customerPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports